import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { LogoMark } from "./Logo";
import { CONTACT, SERVICE_AREAS } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2B2B2B] text-[#F7F3EC]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="inline-flex items-center gap-2.5 mb-5">
            <div className="bg-[#F7F3EC] p-1.5 inline-flex items-center justify-center">
              <LogoMark size={34} />
            </div>
            <div className="flex flex-col justify-center leading-none">
              <span className="font-extrabold tracking-tight text-lg">Bright Oak</span>
              <span
                className="font-bold uppercase tracking-[0.28em] text-[0.55rem] text-[#C68B4E]"
                style={{ marginTop: "4px", marginRight: "-0.28em" }}
              >
                Renovations
              </span>
            </div>
          </div>
          <p className="text-sm text-[#F7F3EC]/70 leading-relaxed max-w-xs">
            Renovation, rooted in craft. Premium general contracting for homes across
            Waterloo Region and beyond.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {[Facebook, Instagram, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="Social link"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 border border-[#F7F3EC]/25 flex items-center justify-center hover:bg-[#C68B4E] hover:border-[#C68B4E] transition-colors"
              >
                <Icon size={18} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-bold uppercase tracking-[0.2em] text-xs text-[#C68B4E] mb-5">Explore</h4>
          <ul className="space-y-3 text-sm text-[#F7F3EC]/80">
            <li><Link to="/services" className="hover:text-[#C68B4E] transition-colors">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-[#C68B4E] transition-colors">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-[#C68B4E] transition-colors">About Us</Link></li>
            <li><Link to="/service-area" className="hover:text-[#C68B4E] transition-colors">Service Area</Link></li>
            <li><Link to="/contact" className="hover:text-[#C68B4E] transition-colors">Get a Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold uppercase tracking-[0.2em] text-xs text-[#C68B4E] mb-5">Service Area</h4>
          <ul className="space-y-3 text-sm text-[#F7F3EC]/80">
            {SERVICE_AREAS.slice(0, 6).map((a) => (
              <li key={a.city}>{a.city}, ON</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold uppercase tracking-[0.2em] text-xs text-[#C68B4E] mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-[#F7F3EC]/80">
            <li className="flex items-start gap-3">
              <Phone size={18} strokeWidth={1.5} className="text-[#C68B4E] mt-0.5 shrink-0" />
              <a href={`tel:${CONTACT.phone.replace(/[^0-9+]/g, "")}`} className="hover:text-[#C68B4E] transition-colors">{CONTACT.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={18} strokeWidth={1.5} className="text-[#C68B4E] mt-0.5 shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#C68B4E] transition-colors break-all">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} strokeWidth={1.5} className="text-[#C68B4E] mt-0.5 shrink-0" />
              <span>{CONTACT.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#F7F3EC]/15 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-[#F7F3EC]/50">
          © {new Date().getFullYear()} Bright Oak Renovations. All rights reserved.
        </p>
        <Link to="/admin/login" className="text-xs text-[#F7F3EC]/40 hover:text-[#C68B4E] transition-colors" data-testid="footer-admin-link">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
